export default {
  nav: {
    home: 'Hjem',
    shoppingGuide: 'Indkøbsguide',
    categories: 'Kategorier',
    guides: 'Guider',
    review: 'Anmeldelse',
    shipping: 'Forsendelse',
    safety: 'Sikkerhed',
    articles: 'Artikler',
    cta: 'Køb nu',
  },
  footer: {
    disclaimerTitle: 'Vigtig ansvarsfraskrivelse',
    disclaimer: 'Dette er en uafhængig ressourceside og er ikke tilknyttet AllChinaBuy eller nogen relateret platform. Alle varemærker tilhører deres respektive ejere.',
    safety: 'Sikkerhed',
    privacy: 'Privatliv',
    terms: 'Vilkår',
    about: 'Om',
    copyright: 'Alle rettigheder forbeholdes.',
  },
  notFound: {
    title: 'Side ikke fundet',
    subtitle: 'Siden du leder efter, findes ikke.',
    backHome: 'Tilbage til forsiden',
  },
};